import { ThemeDataType } from '@/modules/types/theme';
import { ResourceType } from '../resource';
import { ReviewerType } from '../reviewers';
import { MuteType } from './muteType.enum';
import { ElearningPublishChannel } from './publish.enum';
import { ViewLinks, PaginationMetadata } from '@/pages/CourseLibrary/types';

// eslint-disable-next-line no-shadow
export enum SyncStatus {
  synced = 1,
  unsynced = 0,
}
// eslint-disable-next-line no-shadow
export enum PublishStatus {
  published = 1,
  unpublished = 0,
}

// eslint-disable-next-line no-shadow
export enum ElearningStatus {
  Draft = 1,
  Review = 2,
}

export interface ElearningFrameElementType {
  type: string;
  style: string;
}

export interface ElearningFrameMetaType {
  style: Record<string, unknown>;
}

export interface TenantType {
  tenantId: string;
  namespace: string;
  subdomain: string | null;
  identifier: string;
  createdAt: string;
  modifiedAt: string;
  isDeleted: boolean | null;
}

export interface LcmsReferenceIdsType {
  id: number;
  encryptedId: string;
  companyId: number;
  departmentId: number;
  categoryId: string;
  parentCourseId: number;
  themeId: number;
}

export interface ChannelsPublishDateType {
  lms?: Date | null;
  courseLibrary?: Date | null;
  videoLibrary?: Date | null;
  scorm?: Date | null;
  breathe?: Date | null;
}

export interface ElearningMetadataType {
  isLibrary: number;
  isVideoLibrary: number;
  isFullService: number;
  isDemo: number;
  isEnabled: number;
  newUntil: string;
  isMigrated: number;
  downloadedFromLcms?: boolean;
  channels?: ChannelsPublishDateType;
}

export interface PlayerMetadataType {
  showMenu: number;
  showResource: number;
  menu: string;
  menuX: number;
  menuY: number;
  mute: MuteType;
  voiceMessage: string;
  playerType: number;
}

export interface TitleMetadataType {
  posX: number;
  posY: number;
  nameSize: string;
  nameFont: string;
  nameColor: string;
}

export interface MultiLanguageMetadataType {
  multiLang: string;
  multiLangX: number;
  multiLangY: number;
}

export type ImportStatus = 'queued' | 'importing' | 'ready' | 'failed';

export interface StatusMetadataType {
  status: number;
  lmsStatus: number;
  scormStatus: number;
  breatheStatus: number;
  courseSync: number;
  lmsSync: number;
  scormSync: number;
  breatheSync: number;
  publishedToReview?: number;
  publishedToLive?: number;
  publishedToScorm?: number;
  publishedToBreathe?: number;
  publishedTo?: string;
  importStatus?: ImportStatus;
}

export interface ElearningDataType {
  id: string;
  name: string;
  /** Set only on published data (publishedEntities.ts); draft assets resolve to /content/ */
  assetBasePath?: string;
  tags: string;
  tenantId: string;
  tenant: TenantType;
  createdAt: string;
  modifiedAt: string;
  publishedToLiveAt?: string | null;
  publishedToReviewAt?: string | null;
  isDeleted: boolean | null;
  description: string;
  version: number;
  units: string;
  lcmsReferenceIds: LcmsReferenceIdsType;
  elearningMetadata: ElearningMetadataType;
  playerMetadata: Partial<PlayerMetadataType>;
  titleMetadata: TitleMetadataType;
  multiLanguageMetadata: MultiLanguageMetadataType;
  statusMetadata: StatusMetadataType;
  toolTip: number;
  bgImageName: string;
  parentElearningId: string | null;
  categoryId: string | null;
  useDefaultTheme: boolean;
  theme?: ThemeDataType;
  resources?: ResourceType[];
  reviewers?: ReviewerType[];
  categories?: { id: string; name: string }[];
}

export interface ElearningType {
  isLoading: boolean;
  isLoaded: boolean;
  // isSaved will be set to false when content will be edited
  isSaved: boolean;
  error?: Error;
  data: null | ElearningDataType;
}

export interface PublishElearningType {
  message?: any;
  statusCode?: any;
  elearningId: string;
  type: string;
  entity: string;
  userId?: string;
  subdomains?: string;
  channel?: ElearningPublishChannel;
  targetRegions?: string[];
}

export interface PaginationType<T> {
  data: T[];
  meta: PaginationMetadata;
  links: ViewLinks;
}

export interface PaginationParams {
  page?: number;
  limit?: number;
  order?: string;
  sort?: string;
  search?: string;
}
